<template>
    <b-sidebar
        v-model="isSidebarOpenScoreLocal"
        id="sidebar-score-right"
        right
        backdrop
        shadow
        width="30em"
        backdrop-variant="dark"
        no-close-on-backdrop
        lazy
        @hidden="closeScoreSidebar"
    >
        <template #title>
            <div class="title-sidebar">
                <strong class="ml-2">Оцените поставку #{{ tempScoreOrderId }}</strong>
            </div>
        </template>
        <div>
            <div class="sidebar-score-order-inner">
                <div class="sidebar-score-order-top">
                    <p class="sidebar-score-order-top-text">Оцените поставку по 10 бальной шкале</p>
                    <div class="sidebar-score-order-top-stars">
                        <b-icon
                            v-for="(star, index) in 10"
                            :key="index"
                            :icon="getIcon(index)"
                            scale="1.5"
                            color="#EA7B27"
                            class="sidebar-score-order-top-star"
                            @click="setScoreStars(index)"
                            @mouseover="hoverStars(index)"
                            @mouseleave="resetHover"
                        ></b-icon>
                    </div>
                </div>

                <div v-if="starsLocal > 0" class="additional-questions">
                    <div class="sub-question">
                        <p>Оцените качество обслуживания</p>
                        <div class="numbers">
                            <b-button
                                v-for="n in 10"
                                :key="n"
                                :variant="scoreTextLocal.kachestvo_obslugivaniya === n ? 'primary' : 'secondary'"
                                @click="setAdditionalRating('kachestvo_obslugivaniya', n)"
                                size="sm"
                            >{{ n }}</b-button>
                        </div>
                    </div>

                    <div class="sub-question">
                        <p>Оцените скорость работы</p>
                        <div class="numbers">
                            <b-button
                                v-for="n in 10"
                                :key="n"
                                :variant="scoreTextLocal.skorost_raboty === n ? 'primary' : 'secondary'"
                                @click="setAdditionalRating('skorost_raboty', n)"
                                size="sm"
                            >{{ n }}</b-button>
                        </div>
                    </div>

                    <div class="sub-question">
                        <p>Оцените уровень профессионализма и компетентности сотрудников, занимавшихся поставкой</p>
                        <div class="numbers">
                            <b-button
                                v-for="n in 10"
                                :key="n"
                                :variant="scoreTextLocal.prof_and_comp_sotrudnikov === n ? 'primary' : 'secondary'"
                                @click="setAdditionalRating('prof_and_comp_sotrudnikov', n)"
                                size="sm"
                            >{{ n }}</b-button>
                        </div>
                    </div>
                </div>

                <div class="sidebar-score-order-body mt-3">
                    <label
                        for="score-order-textarea"
                        class="sidebar-score-order-body-label"
                    >Напишите отзыв о поставке</label>
                    <textarea
                        name="score-order-textarea"
                        id="score-order-textarea"
                        v-model="scoreTextLocal.description"
                        placeholder="Ваш отзыв"
                        class="sidebar-score-order-body-textarea"
                    ></textarea>
                </div>

                <div class="sidebar-score-order-buttons">
                    <b-button
                        class="btn btn-secondary"
                        @click="closeScoreSidebar"
                    >Отмена</b-button>

                    <b-button
                        class="btn btn-primary"
                        @click="saveOrderScore"
                    >Отправить отзыв</b-button>
                </div>
            </div>
        </div>
    </b-sidebar>
</template>

<script>
export default {
    props: {
        isSidebarOpenScore: { type: Boolean, default: false },
        scoreText: { type: String, default: '{}' },
        tempScoreOrderId: { type: Number, default: 0 },
        stars: { type: Number, default: 0 },
    },
    data() {
        return {
            starsLocal: 0,
            scoreTextLocal: {
                description: '',
                kachestvo_obslugivaniya: 0,
                skorost_raboty: 0,
                prof_and_comp_sotrudnikov: 0
            },
            hoverIndex: -1
        }
    },

    watch: {
        isSidebarOpenScore() {
            if (this.isSidebarOpenScore) {
                this.starsLocal = this.stars;
                this.loadDescription();
            }
        }
    },

    computed: {
        isSidebarOpenScoreLocal: {
            get: function() {
                return this.isSidebarOpenScore
            },
            set: function(value) {
                this.$emit('update:isSidebarOpenScore', value)
            }
        },
    },

    mounted() {
        this.starsLocal = this.stars;
        this.loadDescription();
    },

    methods: {
        closeScoreSidebar() {
            this.$emit('closeScoreSidebar')
        },
        saveOrderScore() {
            this.$emit('saveOrderScore', this.starsLocal, JSON.stringify(this.scoreTextLocal));
        },
        setScoreStars(id) {
            this.starsLocal = id + 1;
        },
        hoverStars(index) {
            this.hoverIndex = index;
        },
        resetHover() {
            this.hoverIndex = -1;
        },
        getIcon(index) {
            return (index + 1) > this.starsLocal && (index > this.hoverIndex) ? 'star' : 'star-fill';
        },
        setAdditionalRating(type, value) {
            this.$set(this.scoreTextLocal, type, value);
        },
        loadDescription() {
            try {
                if (this.scoreText && this.scoreText.trim()) {
                    const parsedDescription = JSON.parse(this.scoreText);
                    this.scoreTextLocal.kachestvo_obslugivaniya = parsedDescription.kachestvo_obslugivaniya || 0;
                    this.scoreTextLocal.skorost_raboty = parsedDescription.skorost_raboty || 0;
                    this.scoreTextLocal.prof_and_comp_sotrudnikov = parsedDescription.prof_and_comp_sotrudnikov || 0;
                    this.scoreTextLocal.description = parsedDescription.description || '';
                }
            } catch (e) {
                console.error("Error parsing scoreText JSON:", e);
            }
        }
    }
}
</script>

<style>
.sidebar-score-order-inner {
    display: flex;
    flex-direction: column;
    padding: 0 0 15px 0;
}
.sidebar-score-order-top {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;
}
.sidebar-score-order-top-text {
    margin-bottom: 10px;
}
.sidebar-score-order-top-stars {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.sidebar-score-order-top-star {
    cursor: pointer;
}
.additional-questions {
    margin-top: 20px;
}
.numbers {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.sidebar-score-order-body {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}
.sidebar-score-order-body-label {
    margin-bottom: 10px;
}
.sidebar-score-order-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
}
.sidebar-score-order-body-textarea {
    height: 120px;
    padding: 10px;
}
.sub-question {
    border-left: 1px solid #CCC;
    padding-left: 15px;
    padding-top: 3px;
    padding-bottom: 3px;
    margin-bottom: 10px;
}
.sub-question p {
    line-height: 16px;
}
</style>
